var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(ref){
var title = ref.title;
var country = ref.country;
var url = ref.url;
return _c('v-chip',{key:title,staticClass:"ma-2",attrs:{"color":_vm.color,"outlined":_vm.outlined,"label":""},on:{"click":function($event){url ? _vm.openLink(url) : ""}}},[_c('v-avatar',{attrs:{"left":"","size":"20"}},[_c('flag',{attrs:{"iso":country}})],1),_vm._v(" "+_vm._s(title)+" ")],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }